// extracted by mini-css-extract-plugin
module.exports = {"footer":"RrExcelButton_footer__33WRr"};